import { render } from "./user-profile.vue?vue&type=template&id=8ba870f6&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"

import "./user-profile.vue?vue&type=style&index=0&id=8ba870f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba870f6"]])

export default __exports__